<template lang="">
  <div class="mains">
    <div class="container" id="container">
      <div class="header_title">修改密码</div>
      <div class="top">
        <!-- <h1>修改密码</h1> -->
      </div>
      <div class="main">
        <Form
          :model="formItem"
          :label-width="80"
          style="width: 100%; max-width: 600px; min-width: 300px"
        >
          <FormItem label="旧密码">
            <Input
              v-model="formItem.valueA"
              type="text"
              :autosize="{ minRows: 2, maxRows: 5 }"
              placeholder="输入你旧的密码"
            ></Input>
          </FormItem>
          <FormItem label="新密码">
            <Input
              v-model="formItem.valueB"
              type="text"
              :autosize="{ minRows: 2, maxRows: 5 }"
              placeholder="输入要修改的新密码"
            ></Input>
          </FormItem>

          <FormItem>
            <Button type="primary" @click="updatas()">提交</Button>
          </FormItem>
        </Form>
      </div>
    </div>
    
  </div>
</template>
<script>
import { uppassword, upGDkey } from "@/api/index";
export default {
  data() {
    return {
      formItem: {
        valueA: "",
        valueB: "",
      },
      gd: {
        key: "",
        secret: "",
        map: "",
      },
    };
  },
  methods: {
    updatas() {
      if (this.formItem.valueA == "") {
        this.$Notice.error({ title: "请输入旧的密码！" });
      } else if (this.formItem.valueB == "") {
        this.$Notice.error({ title: "请输入新的密码！" });
      } else {
        uppassword({
          pwd: this.formItem.valueA,
          value: this.formItem.valueB,
        }).then((res) => {
          if (res.code == 200) {
            this.$Notice.success({ title: "修改成功" });
          } else {
            this.$Notice.error({ title: "修改失败！", message: res.data });
          }
        });
      }
    },
    upGDkeys() {
      if (this.gd.key == "") {
        this.$Notice.error({ title: "请输入key" });
      } else if (this.gd.secret == "") {
        this.$Notice.error({ title: "请输入你的密钥" });
      } else if (this.gd.map == "") {
        this.$Notice.error({ title: "请输入map" });
      } else {
        upGDkey({
          keys: this.gd.key,
          secret: this.gd.secret,
          map: this.gd.map,
        }).then((res) => {
          if (res.code == 200) {
            const gd = {
              key: this.gd.key,
              secret: this.gd.secret,
              map: this.gd.map,
            };
            this.$store.commit("ChangGd", gd);
            this.$Notice.success({ title: "修改成功" });
          } else {
            this.$Notice.error({ title: "修改失败！", message: res.data });
          }
        });
      }
    },
  },
};
</script>
<style scoped >
.top {
  width: 100%;
  background: white;
  padding: 15px;
  display: flex;
  flex-direction: row;
}

.select {
  margin-left: 10px;
}

.main {
  background: white;
  display: flex;
  flex-direction: column;
  align-items: left;
}

.page {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
